<template>
  <div>
    <div
      class="component-header-top d-flex justify-content-between align-items-center"
    >
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center" style="margin-right:  30px">
          <img src="@/static/icon/header-top/home2.png" alt="">
          <img class="pl-2" src="@/static/icon/header-top/logo-head.svg" alt="">
        </div>
        <!--      // phần menu admin -->
        <div class="d-flex align-items-center" v-if="userLogin.user_type == 1 || userLogin.user_type == 2">
          <div style="padding-bottom: 5px" class="mr-1" v-for="item in listMenu" :key="item.text"
               :class="[moduleIsSelected(item.url, full_path) ? 'active' : '']"
               @click="nextRouteMenu(item, item.url)"
          >
            <div v-if="hasPermission(item)" class="mr-3">
              <div class="name_menu d-flex align-items-center" v-if="item.subcategory.length == 0"
              >
                <img class="icon-menu" :src="item.icon" alt="">
                <!--                <span>{{ item.text }}</span>-->
                <router-link
                  class="spanLink" :to="{ name: item.name}"
                >{{ item.text }}
                </router-link>
              </div>
              <div v-else>
                <el-dropdown>
                  <div class="el-dropdown-link name_menu d-flex align-items-center">
                    <img class="icon-menu" :src="item.icon" alt="">
                    <span>{{ item.text }}</span>
                    <span><i class="el-icon-arrow-down el-icon--right"></i></span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="subMenu in item.subcategory" :key="subMenu.text">
                      <router-link
                        @click.stop="nextRoute(subMenu.name, subMenu.url)"
                        v-if="hasSubPermission(subMenu)"
                        class="spanLink spanLinkSub" :to="{ name: subMenu.name}"
                      >{{ subMenu.text }}
                      </router-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
        <!--      // phần menu khasch -->
        <div class="d-flex align-items-center" v-if="userLogin.user_type == 3">
          <div style="padding-bottom: 5px" class="mr-1" v-for="item in listMenuGuest" :key="item.text"
               :class="[moduleIsSelected(item.url, full_path) ? 'active' : '']"
               @click="nextRouteMenu(item, item.url)"
          >
            <div v-if="hasPermission(item)" class="mr-3">
              <div class="name_menu d-flex align-items-center" v-if="item.subcategory.length == 0"
              >
                <img class="icon-menu" :src="item.icon" alt="">
                <router-link
                  class="spanLink" :to="{ name: item.name}"
                >{{ item.text }}
                </router-link>
              </div>
              <div v-else>
                <el-dropdown>
                  <div class="el-dropdown-link name_menu d-flex align-items-center">
                    <img class="icon-menu" :src="item.icon" alt="">
                    <span>{{ item.text }}</span>
                    <span><i class="el-icon-arrow-down el-icon--right"></i></span>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="subMenu in item.subcategory" :key="subMenu.text">
                      <router-link
                        @click.stop="nextRoute(subMenu.name, subMenu.url)"
                        v-if="hasSubPermission(subMenu)"
                        class="spanLink spanLinkSub" :to="{ name: subMenu.name}"
                      >{{ subMenu.text }}
                      </router-link>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center">

        <div class="change-language">
          <el-select
            popper-class="change-language"
            v-model="userLogin.language"
            placeholder="Select"
            @change="changeLang()"
          >
            <el-option
              v-for="item in langList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>

        <div class="px-2">
          <el-badge :value="totalNoti" class="item">
            <img @click="showNoti()" style="width: 20px; height: 20px; cursor: pointer"
                 src="@/static/icon/header-top/noti.svg" alt="">
          </el-badge>
        </div>

        <div
          class="dropdown-account"
          ref="dropdownProfile"
          @click="showMenuTop = !showMenuTop"
        >
          <img
            v-if="accountInfo.avatar"
            :src="baseMedia + accountInfo.avatar"
            class="avatar"
          />
          <span v-else><img class="avatar-null" src="@/static/icon/header-top/account.svg"/></span>
          <span class="name">
        {{ accountInfo.company_name ? accountInfo.company_name : accountInfo.name }}
        <img class="down" src="@/static/icon/header-top/down.svg"/>
      </span>
          <ul v-if="showMenuTop">
            <a>
              <span style="color: #007AFF">{{ accountInfo.name }}</span>
            </a>
            <a @click="changePassWord()">
              <span>{{ langByLanguage.account_change_password }}</span>
            </a>
            <a @click="dialogLink = true">
              <span>{{ goLang('Đường dẫn cập nhật trạng thái') }}</span>
            </a>
            <a @click.stop.stop="confirmLogout">
              <span>{{ langByLanguage.account_logout }}</span>
            </a>


          </ul>
        </div>


      </div>
    </div>

    <div class="dialog-no-close">
      <el-dialog
        top="150px"
        width="30%"
        :visible.sync="dialogChangePassWord"
        :show-close="false"
        :close-on-click-modal="false"
        border
      >
        <ChangePassword
          @cancelChange="cancelChange"
        ></ChangePassword>
      </el-dialog>
    </div>

    <div class="dialog-no-close">
      <el-dialog
        top="150px"
        width="45%"
        :visible.sync="dialogNoti"
        :show-close="false"
        border
      >
        <div class="titleLog" style="text-align: center; font-weight: 700; color: #007AFF; padding-bottom: 20px">
          <span>Thông báo</span>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center btn-filter-noti">
            <span :class="filter.un_read == 0 ? 'active-un-read' : ''" @click="filterUnread(0)">Tất cả</span>
            <span :class="filter.un_read == 1 ? 'active-un-read' : ''" @click="filterUnread(1)">Chưa đọc</span>
          </div>
          <div class="d-flex align-items-center" style="cursor: pointer; font-weight: 500; font-size: 12px"
               @click="clickAllNoti()">
            <i class="el-icon-check"></i>
            <span class="pl-1">Đánh dấu tất cả đã đọc</span>
          </div>
        </div>
        <el-scrollbar ref="scrollContainer" height="300px">
          <div style="height: 300px; overflow-y: auto" class="scroll-content" v-infinite-scroll="fetchNoti"
               :infinite-scroll-disabled="isLoading || !hasMore">
            <div v-for="item in listNoti" :key="item.id" class="item">
              <div @click="seenNotiOne(item)"
                   class="d-flex justify-content-between align-items-center content-noti-quote"
                   :class="item.time_seen == 0 ? 'time0' : ''">
                <div class="d-flex align-items-center">
                  <div class="round-box"></div>
                  <div class="d-flex align-items-center" style="cursor: pointer">
                    <img class="avatar-null" src="@/static/icon/header-top/account.svg"/>
                    <span class="pl-2 content-noti">{{ item.content }}</span>
                  </div>
                </div>
                <div class="time" style="font-size: 12px">
                  <span>{{ item.time_create }}</span>
                </div>
              </div>
            </div>
            <div v-if="isLoading" class="loading" style="text-align: center"><i class="el-icon-loading"></i></div>
          </div>
        </el-scrollbar>
      </el-dialog>
    </div>

    <div class="wh_dialog">
      <el-dialog title top="50px" width="40%" :show-close="false" :visible.sync="dialogLink">
        <div class="header-dialog-custom d-flex align-items-center justify-content-between">
          <div class="left">{{ goLang('Đường dẫn cập nhật trạng thái') }}</div>
        </div>
        <div class="form-create">
          <el-form
            label-position="left"
            label-width="50px"
            autocomplete="off"
          >
            <el-form-item label="Url">
              <el-input v-model="modelLink" placeholder="Nhập url" autocomplete="off" clearable></el-input>
            </el-form-item>
          </el-form>
          <div class="btnSubmitForm d-flex justify-content-end align-items-center mt-3">
            <el-button @click="dialogLink = false" class="btn-cancel">Hủy bỏ</el-button>
            <el-button
              :disable="!canSubmit"
              :loading="!canSubmit"
              @click="submitLink()"
              class="btnSubmit"
            >
              <span>Lưu</span>
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
// import ls from "local-storage";
// import store from "@/store";
import {mapActions, mapGetters} from "vuex";
import ChangePassword from "@/views/user/ChangePassword";
import axios from "axios";

export default {
  name: "LayoutHeaderTop",

  components: {
    ChangePassword,
  },
  data() {
    return {
      seach: "",
      showMenuTop: false,
      langList: [
        {
          name: "Tiếng việt",
          value: "vi"
        },
        {
          name: "English",
          value: "en"
        },
        {
          name: "中文",
          value: "zh"
        },
      ],
      // phan noti
      dialogChangePassWord: false,
      isLoading: false,
      hasMore: true,
      dialogNoti: false,
      listNoti: [],
      filter: {
        un_read: 0,
        page: 1,
        per_page: 15,
      },


      translateLanguage: {
        search: ''
      },
      baseMedia: process.env.VUE_APP_MEDIA,

      listMenu: [
        {
          text: "Trang chủ",
          url: "/dashboard",
          name: "home-index",
          icon: require('@/static/icon/header-top/home.png'),
          rootPermission: [],
          subcategory: [],
        },
        {
          text: "Nhập kho",
          url: "/warehouse-import",
          name: "warehouse-import",
          icon: require('@/static/icon/header-top/warehouse.svg'),
          rootPermission: [
            'admin.pallet.index'
          ],
          subcategory: [],
        },
        {
          text: "Hàng chờ xác nhận",
          url: "/pack-unconfirmed",
          name: "pack-unconfirmed",
          icon: require('@/static/icon/menu-left/pack-unconfirmed.png'),
          rootPermission: [],
          subcategory: [],
        },
        {
          text: "Lưu kho",
          url: "/storage-warehouse",
          name: "storage-warehouse",
          icon: require('@/static/icon/header-top/luukho.svg'),
          rootPermission: [
            'admin.warehouse_import.index',
            'admin.warehouse_import.listWarehouseImportComeback',
            'admin.warehouse_import.indexByFeeShip',
          ],
          subcategory: [
            {
              text: "Danh sách lưu kho",
              url: "/storage-warehouse",
              name: "storage-warehouse",
              rootPermission: "admin.warehouse_export.index",
            },
            {
              text: "Lưu kho theo phiếu nhập kho",
              url: "/storage-warehouse/by-bill",
              name: "storage-warehouse-by-bill",
              rootPermission: "admin.warehouse_import.indexByCode",
            },
            {
              text: "Lưu kho theo Khách hàng",
              url: "/storage-warehouse/by-customer",
              name: "storage-warehouse-by-customer",
              rootPermission: "admin.warehouse_import.indexByCustomer",
            },
            {
              text: "Xếp xe dự kiến",
              url: "/storage-warehouse/expected-vehicle-arrangement",
              name: "expected-vehicle-arrangement",
              rootPermission: "",
            },
            {
              text: "Danh sách hàng quay đầu trả khách",
              url: "/storage-warehouse/list-returned-goods",
              name: "list-returned-goods",
              rootPermission: "admin.warehouse_import.listWarehouseImportComeback",
            },
            {
              text: "Danh sách phí ship, phí đóng gỗ",
              url: "/storage-warehouse/list-fee-ship",
              name: "list-fee-ship",
              rootPermission: "admin.warehouse_import.indexByFeeShip",
            },
          ],
        },
        {
          text: "Xuất kho",
          url: "/export-warehouse",
          name: "export-warehouse",
          icon: require('@/static/icon/header-top/xuatkho.svg'),
          rootPermission: [
            'admin.warehouse_export.index',
            'admin.car.index',
            'admin.warehouse_export.listWarehouseExportDetailList'
          ],
          subcategory: [
            {
              text: "Phiếu xuất kho",
              url: "/export-warehouse",
              name: "export-warehouse",
              rootPermission: "admin.warehouse_export.index",
            },
            {
              text: "Danh sách xe",
              url: "/export-warehouse/car",
              name: "export-warehouse-car",
              rootPermission: "admin.car.index",
            },
            {
              text: "Danh sách hàng xuất",
              url: "/export-warehouse/list-goods",
              name: "export-warehouse-list-goods",
              rootPermission: "admin.warehouse_export.listWarehouseExportDetailList",
            },
          ],
        },
        {
          text: "Trả Hàng",
          url: "/return-orders",
          name: "return-orders",
          icon: require('@/static/icon/return_order/head.svg'),
          rootPermission: [
            'admin.warehouse_export.listBagReturn',
            'admin.warehouse_export.listOrderReturnHistory'
          ],
          subcategory: [
            {
              text: "Trả hàng",
              url: "/return-orders",
              name: "return-orders",
              rootPermission: 'admin.warehouse_export.listBagReturn',
            },
            {
              text: "Lịch sử trả hàng",
              url: "/return-orders/history",
              name: "return-history-orders",
              rootPermission: "admin.warehouse_export.listOrderReturnHistory",
            },
          ],
        },
        {
          text: "Đại lý",
          url: "/agency",
          name: "agency",
          icon: require('@/static/icon/header-top/daily.svg'),
          rootPermission: [
            'admin.customer_bag.index'
          ],
          subcategory: [
            {
              text: "Danh sách bill",
              url: "/agency",
              name: "agency",
              rootPermission: "admin.customer_bag.index",
            },
            {
              text: "Lưu  kho chờ xuất",
              url: "/storage-waiting-export",
              name: "storage-waiting-export",
              rootPermission: "",
            },
          ],
        },
        {
          text: "Tài khoản",
          url: "/account",
          name: "account",
          icon: require('@/static/icon/header-top/taikhoan.svg'),
          rootPermission: [
            'admin.user.index',
            'admin.role.index',
            'admin.customer.index',
          ],
          subcategory: [
            {
              text: "Danh sách nhân viên",
              url: "/account/list-user",
              name: "account-lists-user",
              rootPermission: "admin.user.index",
            },
            {
              text: "Vai trò",
              url: "/account/roles",
              name: "account-roles",
              rootPermission: "admin.role.index",
            },
            {
              text: "Danh sách khách hàng",
              url: "/account/customer-list",
              name: "customers-list",
              rootPermission: "admin.customer.index",
            },
          ],
        },
        {
          text: "Cài đặt",
          url: "/setting",
          name: "setting",
          icon: require('@/static/icon/header-top/caidat.svg'),
          rootPermission: [
            'admin.company.index',
            'admin.warehouse.index',
            'admin.area.index',
            'admin.car.index',
          ],
          subcategory: [
            {
              text: "Danh sách công ty",
              url: "/setting/company",
              name: "setting-company",
              rootPermission: "admin.company.index",
            },
            {
              text: "Danh sách kho",
              url: "/setting/warehouse",
              name: "setting-warehouse",
              rootPermission: "admin.warehouse.index",
            },
            {
              text: "Vị trí",
              url: "/setting/location",
              name: "setting-location",
              rootPermission: "admin.area.index",
            },
            {
              text: "Danh sách trạng thái bao",
              url: "/setting/bag-status",
              name: "setting-bag-status",
              rootPermission: "admin.bag_status.index",
            },

          ],
        },

      ],
      subCategoryLength: 0,
      totalStatusProcess: 0,

      userLoginPer: {},
      userLogin: {},

      // Webhook:
      canSubmit: true,
      dialogLink: false,
      modelLink: ""
    };
  },
  computed: {
    ...mapGetters(["path", "full_path"]),
    ...mapGetters("account", ["accountInfo"]),
    ...mapGetters(["langByLanguage", "totalNoti"]),

    listMenuGuest() {
      return [
        {
          text: this.langByLanguage.menu_home,
          url: "/dashboard",
          name: "home-index",
          icon: require('@/static/icon/header-top/home.png'),
          rootPermission: [],
          subcategory: [],
        },
        {
          text: this.langByLanguage.agency_index_title,
          url: "/agency",
          name: "agency",
          icon: require('@/static/icon/header-top/daily.svg'),
          rootPermission: [
            'admin.customer_bag.index'
          ],
          subcategory: [],
        },
        {
          text: this.langByLanguage.menu_storage_export,
          url: "/storage-waiting-export",
          name: "storage-waiting-export",
          icon: require('@/static/icon/header-top/luukho.svg'),
          rootPermission: [],
          subcategory: [],
        },
      ];
    }

  },
  mounted() {
    document.addEventListener("click", this.documentClick);
    // console.log(this.accountInfo, 9999)
    this.socketNoti();
    this.fetchUserLogin();
  },
  destroyed() {
    document.removeEventListener("click", this.documentClick);
  },
  methods: {
    ...mapActions(["setSocketConect"]),
    ...mapActions("account", ["getAccountInfo"]),
    ...mapActions(["setLangByLanguage", "setUseLanguage", "setPermissionUser", "setTotalNoti"]),
    // phan thong bao
    socketNoti() {
      setTimeout(() => {
        // Join vào room
        this.$socket.emit("join-to-room-code", this.accountInfo.code);
      }, 2000);
    },

    submitLink() {
      if (this.modelLink == '') {
        this.$notify({
          title: this.langByLanguage.action_warning,
          message: this.goLang('Vui lòng nhập link Url'),
          type: "warning",
        });
        return;
      }
      this.canSubmit = false;
      let data = {
        link_webhook: this.modelLink,
      }
      axios.post("auth/update-link-webhook", data).then((response) => {
        this.canSubmit = true;
        switch (response.data.code) {
          case 200:
            this.dialogLink = false;
            this.$notify({
              message: this.langByLanguage.api_success,
              type: "success",
            });
            break;
          default:
            this.$notify.error({
              title: this.langByLanguage.api_warning,
              message: this.langByLanguage.api_warning_admin,
            });
            break;
        }
      });
    },

    updateMenuItems() {
      let item = this.listMenu.find(item => item.url.trim() === '/agency');
      if (item) {
        item.text = this.langByLanguage.menu_agency;
      }
      item = this.listMenu.find(item => item.url.trim() === '/dashboard');
      if (item) {
        item.text = this.langByLanguage.menu_home;
      }
      item = this.listMenu.find(item => item.url.trim() === '/warehouse-import');
      if (item) {
        item.text = this.langByLanguage.menu_import;
      }
      item = this.listMenu.find(item => item.url.trim() === '/export-warehouse');
      if (item) {
        item.text = this.langByLanguage.menu_export;
      }
      item = this.listMenu.find(item => item.url.trim() === '/storage-warehouse');
      if (item) {
        item.text = this.langByLanguage.menu_storage;
      }
      item = this.listMenu.find(item => item.url.trim() === '/account');
      if (item) {
        item.text = this.langByLanguage.menu_account;
      }
      item = this.listMenu.find(item => item.url.trim() === '/setting');
      if (item) {
        item.text = this.langByLanguage.menu_setting;
      }
      let item2 = this.listMenu.find(item => item.url.trim() === '/dashboard');
      if (item2) {
        item2.text = this.langByLanguage.menu_home;
      }
      let item3 = this.listMenu.find(item => item.url.trim() === '/storage-warehouse');
      if (item3) {
        item3.text = this.langByLanguage.menu_storage;
      }
      item = this.listMenu.find(item => item.url.trim() === '/return-orders');
      if (item) {
        item.text = this.goLang('Trả hàng');
      }


      this.listMenu.forEach(menu => {
        if (menu.subcategory && menu.subcategory.length) {
          menu.subcategory.forEach(sub => {
            if (sub.url === "/account/list-user") {
              sub.text = this.langByLanguage.menu_account_agents; // Gán lại giá trị text
            }
          });
        }
      });
      this.listMenu.forEach(menu => {
        if (menu.subcategory && menu.subcategory.length) {
          menu.subcategory.forEach(sub => {
            if (sub.url === "/account/roles") {
              sub.text = this.langByLanguage.menu_account_roles; // Gán lại giá trị text
            }
          });
        }
      });
      this.listMenu.forEach(menu => {
        if (menu.subcategory && menu.subcategory.length) {
          menu.subcategory.forEach(sub => {
            if (sub.url === "/account/customer-list") {
              sub.text = this.langByLanguage.menu_account_customers; // Gán lại giá trị text
            }
          });
        }
      });


      this.listMenu.forEach(menu => {
        if (menu.subcategory && menu.subcategory.length) {
          menu.subcategory.forEach(sub => {
            if (sub.url === "/setting/company") {
              sub.text = this.langByLanguage.menu_setting_company; // Gán lại giá trị text
            }
          });
        }
      });

      this.listMenu.forEach(menu => {
        if (menu.subcategory && menu.subcategory.length) {
          menu.subcategory.forEach(sub => {
            if (sub.url === "/setting/warehouse") {
              sub.text = this.langByLanguage.menu_setting_warehouse; // Gán lại giá trị text
            }
          });
        }
      });

      this.listMenu.forEach(menu => {
        if (menu.subcategory && menu.subcategory.length) {
          menu.subcategory.forEach(sub => {
            if (sub.url === "/setting/location") {
              sub.text = this.langByLanguage.menu_setting_location; // Gán lại giá trị text
            }
            if (sub.url === "/storage-warehouse/expected-vehicle-arrangement") {
              sub.text = this.langByLanguage.menu_arrangement; // Gán lại giá trị text
            }
            if (sub.url === "/setting/bag-status") {
              sub.text = this.goLang('Danh sách trạng thái bao'); // Gán lại giá trị text
            }
          });
        }
      });

      this.listMenu.forEach(menu => {
        if (menu.subcategory && menu.subcategory.length) {
          menu.subcategory.forEach(sub => {
            if (sub.url === "/export-warehouse/car") {
              sub.text = this.langByLanguage.menu_setting_car; // Gán lại giá trị text
            }
            if (sub.url === "/export-warehouse") {
              sub.text = this.langByLanguage.storage_warehouse_release_note; // Gán lại giá trị text
            }
            if (sub.url === "/storage-warehouse") {
              sub.text = this.langByLanguage.menu_storage_list;
            }
            if (sub.url === "/storage-warehouse/by-bill") {
              sub.text = this.langByLanguage.menu_storage_by_bill;
            }
            if (sub.url === "/storage-warehouse/by-customer") {
              sub.text = this.langByLanguage.menu_storage_by_customer;
            }
            if (sub.url === "/agency") {
              sub.text = this.langByLanguage.agency_index_title;
            }
            if (sub.url === "/storage-waiting-export") {
              sub.text = this.langByLanguage.menu_storage_export;
            }
            if (sub.url === "/return-orders/history") {
              sub.text = this.goLang('Lịch sử trả hàng');
            }
            if (sub.url === "/return-orders") {
              sub.text = this.goLang('Trả hàng');
            }
            if (sub.url === "/storage-warehouse/list-returned-goods") {
              sub.text = this.goLang('Danh sách hàng quay đầu trả khách');
            }
            if (sub.url === "/export-warehouse/list-goods") {
              sub.text = this.goLang('Danh sách hàng xuất');
            }
            if (sub.url === "/storage-warehouse/list-fee-ship") {
              sub.text = this.goLang('Danh sách phí ship, phí đóng gỗ');
            }
          });
        }
      });
    },

    fetchUserLogin() {
      axios.get("auth/user-login").then((response) => {
        this.loading = false
        switch (response.data.code) {
          case 200:
            this.userLogin = response.data.data.user
            this.userLoginPer = Object.values(response.data.data.rolePermission);
            this.setLangByLanguage(response.data.data.langByLanguage);
            this.setUseLanguage(response.data.data.user.language);
            this.setTotalNoti(response.data.data.total_noti_unread);
            this.modelLink = this.userLogin.link_webhook;

            var obj_data = {
              user_type: this.userLogin.user_type,
              permission: this.userLoginPer,
            }
            this.setPermissionUser(obj_data);

            setTimeout(() => {
              this.updateMenuItems();
            }, 100);
            break;
          default:
            this.$notify.error({
              title: this.langByLanguage.api_warning,
              message: this.langByLanguage.api_warning_admin,
            });
            break;
        }
      }).catch(errors => {
        console.log(errors)
      });
    },

    showNoti() {
      this.filter.page = 1;
      this.hasMore = true;
      this.isLoading = false;
      this.listNoti = [];
      this.dialogNoti = true;
      this.fetchNoti();
    },
    filterUnread(num) {
      this.listNoti = [];
      this.filter.un_read = num;
      this.filter.page = 1;
      this.isLoading = false;
      this.hasMore = true;
      this.fetchNoti();
    },
    async fetchNoti() {
      if (this.isLoading || !this.hasMore) return;
      this.isLoading = true
      this.loadingLog = true;
      await axios.get("notification", {params: this.filter}).then((response) => {
        this.loadingLog = false;
        switch (response.data.code) {
          case 200:
            var itemData = response.data.data.items;
            // phần loading thêm data
            if (itemData.length === 0) {
              this.hasMore = false;
            } else {
              this.listNoti.push(...itemData);
              this.filter.page++;
            }
            break;
          default:
            this.$notify.error({
              title: this.langByLanguage.api_warning,
              message: this.langByLanguage.api_warning_admin,
            });
            break;
        }
        this.isLoading = false;
      });
    },
    // xem 1 noti
    seenNotiOne(item) {
      if (item.time_seen == 0) {
        axios.post("notification/click-noti/" + item.id).then((response) => {
          switch (response.data.code) {
            case 200:
              if (this.totalNoti > 0) {
                this.setTotalNoti(this.totalNoti - 1);
              }
              this.dialogNoti = false;
              this.showDetailQuote(item)
              break;
            default:
              this.$notify.error({
                title: "Error",
                message: "Đã có lỗi xảy ra. Vui lòng liên hệ Admin !",
              });
              break;
          }
        });
      } else {
        this.showDetailQuote(item)
      }
    },
    //  xem hết noti
    clickAllNoti() {
      this.listNoti.forEach((i) => {
        i.time_seen = 1
      });
      axios.post("notification/click-all-noti").then((response) => {
        switch (response.data.code) {
          case 200:
            // this.accountInfo.total_noti_unread = 0;
            this.setTotalNoti(0);
            break;
          default:
            this.$notify.error({
              title: this.langByLanguage.api_warning,
              message: this.langByLanguage.api_warning_admin,
            });
            break;
        }
      });
    },

    showDetailQuote(item) {
      const currentRoute = this.$route;
      const targetQuery = {quote_code: item.data.quote_code};

      this.dialogNoti = false;

      if (item.name == 'change-company-xnk') {
        if (
          currentRoute.name !== "return-goods-list"
        ) {
          this.$router.push({
            name: "return-goods-list",
          });
        }
        return;
      }


      if (item.name === 1006) {
        // Nếu name là 1006 thì chuyển đến quote-update với quote_id
        if (
          currentRoute.name !== "quote-update" ||
          currentRoute.params.quote_id !== item.data.quote_id
        ) {
          this.$router.push({
            name: "quote-update",
            params: {quote_id: item.data.quote_id},
          });
        }
        return;
      }


      if (
        currentRoute.name === 'history-quote' &&
        currentRoute.query.quote_code === targetQuery.quote_code
      ) {
        // Already on the correct route with the correct query, do nothing
        return;
      }

      if (currentRoute.name === 'history-quote') {
        this.$router.replace({
          name: "history-quote",
          query: targetQuery,
        });
      } else {
        this.$router.push({
          name: "history-quote",
          query: targetQuery,
        });
      }
    },


    changePassWord() {
      this.dialogChangePassWord = true;
    },
    cancelChange() {
      this.dialogChangePassWord = false;
    },
    hasPermission(menu) {
      if (this.userLogin.user_type == 1) {
        return true;
      }

      if (menu.rootPermission.length == 0) {
        return true;
      }
      let permissions = [];
      /*if (
        undefined !== this.accountInfo.permissions &&
        this.accountInfo.permissions.length > 0
      ) {
        this.accountInfo.permissions.forEach((e) => {
          permissions.push(e.name);
        });
      }*/
      if (
        undefined !== this.userLoginPer &&
        this.userLoginPer.length > 0
      ) {
        this.userLoginPer.forEach((e) => {
          permissions.push(e);
        });
      }
      return permissions.some((r) => menu.rootPermission.includes(r));
    },
    hasSubPermission(subMenu) {
      if (this.userLogin.user_type == 1) {
        return true;
      }
      //
      if (subMenu.rootPermission === "") {
        return true;
      }
      let permissions = [];
      /*if (
        undefined !== this.accountInfo.permissions &&
        this.accountInfo.permissions.length > 0
      ) {
        this.accountInfo.permissions.forEach((e) => {
          permissions.push(e.name);
        });
      }*/
      if (
        undefined !== this.userLoginPer &&
        this.userLoginPer.length > 0
      ) {
        this.userLoginPer.forEach((e) => {
          permissions.push(e);
        });
      }
      //
      return permissions.includes(subMenu.rootPermission);
    },
    moduleIsSelected(modules, path) {
      if (undefined !== path && path.includes(modules)) {
        this.listMenu.forEach((i) => {
          if (modules == i.url) {
            this.subCategoryLength = i.subcategory.length;
          }
        })
        return true;
      }
      return false;
    },
    nextRoute(name, full_path) {
      if (this.full_path !== full_path) {
        if (undefined !== name) {
          this.$router.push({name: name});
        }
      }
    },
    nextRouteMenu(menu, full_path) {
      if (menu.rootPermission.length === 0) {
        this.$router.push({name: menu.name});
        return;
      }
      let permissions = [];
      if (
        undefined !== this.accountInfo.permissions &&
        this.accountInfo.permissions.length > 0
      ) {
        this.accountInfo.permissions.forEach((e) => {
          permissions.push(e.name);
        });
      }
      let listRoute = [];
      menu.subcategory.forEach((element) => {
        if (permissions.includes(element.rootPermission)) {
          listRoute.push(element.name).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err
            }
          })
        }
      });
      if (this.full_path !== full_path) {
        if (undefined !== name) {
          // this.$router.push({ name: listRoute[0] });
          this.$router.push({name: menu.name}).catch(err => {
            if (err.name !== 'NavigationDuplicated') {
              throw err;
            }
          });
        }
      }
    },

    documentClick(e) {
      let el = this.$refs.dropdownProfile;
      let target = e.target;
      if (el !== target && !el.contains(target)) {
        this.showMenuTop = false;
      }
    },

    ...mapActions("account", ["removeAccountInfo"], ["getAccountInfo"]),
    confirmLogout() {
      this.$confirm(this.langByLanguage.account_logout_confirm, this.langByLanguage.action_warning, {
        confirmButtonText: this.langByLanguage.action_ok,
        cancelButtonText: this.langByLanguage.action_cancel,
        type: "warning",
      })
        .then(() => {
          this.removeAccountInfo();
        })
        .catch(() => {
        });
    },

    // đổi ngôn ngữ
    changeLang() {
      this.canSubmit = false;
      let data = {
        language: this.userLogin.language,
      }
      axios.post("auth/update-language", data).then((response) => {
        this.canSubmit = true;
        switch (response.data.code) {
          case 200:
            localStorage.setItem('language', data.language)
            location.reload()
            break;
          default:
            this.$notify.error({
              title: this.langByLanguage.api_warning,
              message: this.langByLanguage.api_warning_admin,
            });
            break;
        }
      });
    },
  },

  sockets: {
    connect() {
      this.socketNoti();
      setTimeout(() => {
        this.setSocketConect(true);
      }, 3000);
    },
    disconnect() {
      this.setSocketConect(false);
    },
    "global-info-one-crm": function (data) {
      console.log(data);
      if (data.channel == 'noti-admin-one-crm') {
        this.setTotalNoti(this.totalNoti + 1);
      }
    },
  }
};
</script>

<style lang="css" scoped>
.component-header-top {
  height: 50px;
  padding: 0px 15px;
  box-shadow: 0px 4px 4px 0px #DFE8FD;
  margin-bottom: 3px;
}

.seach-global {
  min-width: 200px;
}

.dropdown-account {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 100%;
  padding: 0px 3px 0px 10px;
  position: relative;
}

.dropdown-account img {
  margin-right: 8px;
}

.dropdown-account .down {
  width: 10px;
  margin-right: 0px;
  margin-left: 5px;
}

.dropdown-account .name {
  color: rgba(0, 0, 0, 1);
  font-size: 13px;
  line-height: 24px;
  font-weight: 500;
}

.dropdown-account ul {
  position: absolute;
  top: 50px;
  right: 0px;
  margin: 0px;
  width: 225px;
  background-color: #fff;
  padding: 5px 0px 5px 0px;
  z-index: 1000;
  border: 1px solid #f2f2f2;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05), 0 1px 0 rgba(0, 0, 0, 0.05);
}

.dropdown-account ul a {
  list-style-type: none;
  height: 35px;
  display: flex;
  align-items: center;
  padding-left: 15px;
  text-decoration: none;
  color: #2c3e50;
}

.dropdown-account ul a:hover {
  background-color: #f2f2f2;
}

.dropdown-account ul a.divider {
  height: 1px;
  background-color: #ccc;
  margin-bottom: 5px;
}

.name_menu {
  color: rgba(0, 0, 0, 1);
  font-weight: 500;
  font-size: 13px;
  line-height: 100%;
  margin-right: 10px;
  cursor: pointer;
  height: 40px;
}

.name_menu .icon-menu {
  padding-right: 5px;
  //width: 20px;
  //height: 30px;
}

.active {
  border-bottom: 5px solid #FFB800;
}

.exchange-rate {
  padding: 5px 10px;
  color: #007AFF;
  font-weight: 500;
  background: #E8F3FF;
}

.content-noti-quote {
  padding: 10px;
  margin-bottom: 5px;
}

.content-noti {
  font-weight: 600;
  font-size: 13px;
  line-height: 31px;
  letter-spacing: 0px;
}

.time0 {
  background: #F5F5F5;
  border-radius: 5px;
}

.btn-filter-noti {
  padding: 10px 0;
}

.btn-filter-noti span {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.active-un-read {
  background: #EBF5FF;
  border-radius: 5px;
}
</style>
<style type="text/css">
.component-header-top input {
  border-radius: 25px;
  height: 28px;
  font-size: 12px;
  border: none;
}

.component-header-top .el-input__icon {
  line-height: 28px;
}

.avatar {
  max-width: 100%;
  border-radius: 50%;
  width: 35px;
  height: 35px;
}

.seach-global input {
  border: 1px solid #CFCDCD;
}

.avatar-null {
  background: #c2c2c2;
  border-radius: 50%;
}

.spanLink {
  color: #000000 !important;
  text-decoration: none;
}

.spanLinkSub {
  display: block;
  width: 100%;
  font-size: 12px !important;
}
</style>

<style type="text/css">
.change-language {
  width: 150px;
}

.change-language .el-input__inner {
  border: 1px solid #ccc;
}
</style>

<style type="text/css" scoped>
.wh_dialog .header-dialog-custom {
  height: 56px;
  padding-left: 30px;
}
</style>
